interface FlickrAlbumProps {
  event: string;
  venue: string;
  href: string;
  imageurl: string;
}

export default function FlickrAlbum({ event, venue, href, imageurl }: FlickrAlbumProps) {
  return (
    <div className="p-3" style={{ textAlign: 'center' }}>
      <h4>{event}</h4>
      <h5>@ {venue}</h5>
      <div style={{ width: 320, height: 260, margin: 'auto' }}>
        <a data-flickr-embed="true" href={href} title={event}>
          <img src={imageurl} width="320" height="260" alt={event} />
        </a>
      </div>
    </div>
  );
}
